import { BaseRequests } from "../../../config/BaseRequests";
import { adsApiEndpoints } from "../api/ads.api";
import {
  Ad,
  CreateAdDto,
  ItemDetails,
  UpdateAdDto,
  UpdateItemDetailsDto,
} from "../dto/ads.dto";
import { PaginatedResponse } from "../../../shared/dto/pagination.dto";

export class AdsService {
  static getAds = (
    eventType: string,
    page: number,
    limit: number
  ): Promise<PaginatedResponse<Ad>> =>
    BaseRequests.get(adsApiEndpoints.getAds(eventType, page, limit));

  static getAdById = (id: string, event: string): Promise<ItemDetails> =>
    BaseRequests.get(adsApiEndpoints.getAdById(id, event));

  static updateItemDetails = (
    id: string,
    event: string,
    data: UpdateItemDetailsDto
  ): Promise<ItemDetails> =>
    BaseRequests.patch(adsApiEndpoints.updateItemDetails(id, event), data);

  static deleteItemDetails = (
    id: string,
    event: string
  ): Promise<{ message: string }> =>
    BaseRequests.delete(adsApiEndpoints.deleteItemDetails(id, event));

  static createAd = (data: CreateAdDto): Promise<Ad> =>
    BaseRequests.post(adsApiEndpoints.createAd, data);

  static updateAd = (id: string, data: UpdateAdDto): Promise<Ad> =>
    BaseRequests.put(adsApiEndpoints.updateAd(id), data);

  static deleteAd = (id: string): Promise<void> =>
    BaseRequests.delete(adsApiEndpoints.deleteAd(id));
}
